import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {RootState} from 'common/src/redux/store';
import aiContentProjectApi from '../../../aiContentProject.api';
import {
  RemoteAiContentProject,
  UpdateGenerationSetupRequest,
} from '../../../aiContentProject.types';
import {setError, setProject} from '../aiContentProject.slice';

const updateGenerationSetup = createAsyncThunk<
  RemoteAiContentProject,
  {projectId: number; request: UpdateGenerationSetupRequest},
  {state: RootState}
>(
  `${BreadcrumbName.AiContentProjectPage}/updateGenerationSetup`,
  async ({projectId, request}, {dispatch, getState, rejectWithValue}) => {
    const state = getState();
    const currentProject = state.aiContentProjectPage?.project;

    if (!currentProject || currentProject.id !== projectId) {
      return rejectWithValue('Project not loaded');
    }

    dispatch(setError(null));

    try {
      await aiContentProjectApi.updateGenerationSetup({
        projectId,
        request,
      });

      // Fetch the updated project
      const updatedProject = await aiContentProjectApi.getAiContentProjectById(
        projectId,
      );
      dispatch(setProject(updatedProject));

      return updatedProject;
    } catch (error) {
      // ApiError is a plain object, not an Error instance, so check for message property
      const errorMessage =
        error instanceof Error
          ? error.message
          : error && typeof error === 'object' && 'message' in error
            ? String(error.message)
            : 'Failed to update generation setup';
      dispatch(setError(errorMessage));

      // Create a standard Error object so components can handle it consistently
      const standardError = new Error(errorMessage);

      return rejectWithValue(standardError);
    }
  },
);

export default updateGenerationSetup;
